/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import {createSlice, PayloadAction} from '@reduxjs/toolkit'

interface UserInfo {
    username: string,
    groups: string[],
    person_id: string,
    user_id: string,
    firstname: string,
    surname: string,
    title: string
}

interface AuthState {
    isAuthenticated: boolean,
    userInfo: UserInfo | null
}

const initialAuthState: AuthState = {
    isAuthenticated: false,
    userInfo: null
}

const authSlice = createSlice({
    name: 'auth',
    initialState: initialAuthState,
    reducers: {
        login: state => {
            state.isAuthenticated = true;
        },
        logout: state => {
            state.isAuthenticated = false;
        },
        setUserInfo: (state, action: PayloadAction<UserInfo>) => {
            state.userInfo = action.payload;
        }
    }
})

export const {login, logout, setUserInfo} = authSlice.actions
export const authReducer = authSlice.reducer
